import { getByType } from 'utils/stuff.js'
import * as R from 'ramda'
import { tasks, repairmen } from './entities'
let attachments = state => state.attachments

let extRepMan = (state) => (repairman) => ({
		...repairman
	  , tasksActive: R.values(R.filter(task => !!~repairman.tasks.indexOf(task._id) && !task.done, tasks(state)))
	  , tasksDone: R.values(R.filter(task => !!~repairman.tasks.indexOf(task._id) && task.done, tasks(state)))
	  , comments: (repairman.comments)?R.map(
			commentData =>({
				...commentData
			  , attachments: (commentData.attachmentsIDs)?
					R.map(
						attachmentID =>
							(attachments(state)[repairman._id]
							&& attachments(state)[repairman._id].attachments[attachmentID.id])?
								attachments(state)[repairman._id].attachments[attachmentID.id]
								: false
						, commentData.attachmentsIDs
					)
					: {}
			})
			, repairman.comments)
			: []
})


export default (state) => R.map(extRepMan(state), repairmen(state))



// WEBPACK FOOTER //
// ./src/selectors/repairman.js